// @flow
import { createFormReducer } from 'redux-pure-form';
import type { Reducer } from 'redux';

import { GET_TOTAL, ADD_INVOICE, SAVE_INVOICE, GET_INVOICES } from './invoice.const.js';

import {
  BUY_TRANSACTION,
  REFAUND_TRANSACTION,
  EDIT_TRANSACTION
} from '../transaction/transaction.const.js';

export const unpaidInvoicesList = (state: List = []) => state;

export const defaultInvoice = (state: number | null = 0) => state;

export const invoicesList = (state: List = [], action: Action) => {
  switch (action.type) {
    case GET_INVOICES:
      return Object.keys(action.payload.invoices);
    default:
      return state;
  }
};

export const invoices = (state: $ElementType<ReduxState, 'invoices'> = {}, action: Action) => {
  switch (action.type) {
    case GET_INVOICES:
      return {
        ...state,
        ...action.payload.invoices
      };
    case EDIT_TRANSACTION:
    case REFAUND_TRANSACTION:
      return {
        ...state,
        [action.payload.invoice.id]: {
          ...state[action.payload.invoice.id],
          ...action.payload.invoice
        }
      };
    default:
      return state;
  }
};

const invoiceHandler: Reducer<Product, Action> = createFormReducer('invoice', {});
export const invoice = (state: $ElementType<ReduxState, 'invoice'> = {}, action: Action) => {
  switch (action.type) {
    case GET_TOTAL:
    case ADD_INVOICE:
    case SAVE_INVOICE:
    case EDIT_TRANSACTION:
    case REFAUND_TRANSACTION:
      return {
        ...state,
        ...action.payload.invoice
      };
    default:
      return invoiceHandler(state, action);
  }
};

const invoicePayHandler: Reducer<Invoice, Action> = createFormReducer('invoicePay', {});
export const invoicePay = (state: $ElementType<ReduxState, 'invoicePay'> = {}, action: Action) => {
  switch (action.type) {
    case BUY_TRANSACTION:
      return {
        ...state,
        [action.payload.transaction.id]: '0'
      };
    default:
      return invoicePayHandler(state, action);
  }
};

export const URL = (state: $ElementType<ReduxState, 'URL'> = {}) => state;
